import Partners from '@/components/partners/Partners'
import CreatePartner from '@/components/partners/CreatePartner'
import Enum from '@/shared/enum'

let partnersRoutes = [
  {
    meta: {
      title: 'menu.partners',
      ico: 'handshake-o',
      permission: ['Pages.Partners'],
    },
    path: '/partners',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'partners',
        path: '',
        meta: {permission: ['Pages.Partners.View']},
        component: Partners,
      },
      {
        name: 'partners_create',
        path: 'create',
        props: {compMode: Enum.Mode.CREATE},
        meta: {permission: ['Pages.Partners.Create']},
        component: CreatePartner,
      },
      {
        name: 'partners_edit',
        path: 'edit/:id',
        props: {compMode: Enum.Mode.UPDATE},
        meta: {permission: ['Pages.Partners.Create']},
        component: CreatePartner,
      },
      {
        name: 'partners_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ},
        meta: {permission: ['Pages.Partners.View']},
        component: CreatePartner,
      },
      {
        name: 'partners_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY},
        meta: {permission: ['Pages.Partners.Create']},
        component: CreatePartner,
      },
    ],
  },
  {
    meta: {
      title: 'menu.coinvestor',
      ico: 'handshake-o',
      permission: ['Pages.Partners'],
      hide: true,
    },
    path: '/coinvestor',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'coinvestor_create',
        path: 'create',
        props: {compMode: Enum.Mode.CREATE, coinvestor: true},
        meta: {permission: ['Pages.Partners.Create']},
        component: CreatePartner,
      },
      {
        name: 'coinvestor_edit',
        path: 'edit/:id',
        props: {compMode: Enum.Mode.UPDATE, coinvestor: true},
        meta: {permission: ['Pages.Partners.Create']},
        component: CreatePartner,
      },
      {
        name: 'coinvestor_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ, coinvestor: true},
        meta: {permission: ['Pages.Partners.View']},
        component: CreatePartner,
      },
      {
        name: 'coinvestor_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY, coinvestor: true},
        meta: {permission: ['Pages.Partners.Create']},
        component: CreatePartner,
      },
    ],
  },
]

export default partnersRoutes



// WEBPACK FOOTER //
// ./src/router/partners.js